import { PropsWithChildren, useCallback, useEffect, useState } from 'react'

import { CartContext } from './CartContext'
//TODO - move cart models into models directory
import { CartItem, CartItemSet, CartItemSlot, UpgradeItemSet, useCart } from '../../hooks'

interface Props {

  itemSet?: CartItemSet
}

export const CartProvider: React.FC<PropsWithChildren<Props>> = ({ children, itemSet }) => {
  const cart = useCart(itemSet)

  const [items, setItems] = useState<CartItem[]>()
  const [upgrades, setUpgrades] = useState<UpgradeItemSet[]>()
  const [total, setTotal] = useState<number>()
  const [msrp, setMsrp] = useState<number>()
  const [savingsPercent, setSavingsPercent] = useState<number>()
  const [refreshCount, setRefreshCount] = useState(0)

  useEffect(() => {
    if (cart) {
      setUpgrades(cart.upgrades())
      setItems(cart.data.items)
      setTotal(cart.getTotal())
      setMsrp(cart.getMsrp())
      setSavingsPercent(cart.getSavingsPercent())
    }
  }, [cart, refreshCount])
 //
  const refresh = useCallback(() => {
    setRefreshCount(value => value + 1)
  }, [ setRefreshCount ])

  const removeItem = useCallback((slot: CartItemSlot) => {
    cart?.removeItem(slot)
    cart?.save()
    refresh()
  }, [ cart, refresh ])

  const addItem = useCallback((slot: CartItemSlot) => {
    cart?.addItem(slot)
    cart?.save()
    refresh()
  }, [ cart, refresh ])

  const addCartItem = useCallback((slot: CartItemSlot, item: CartItem) => {
    cart?.addCartItem(slot, item)
    cart?.save()
    refresh()
  }, [cart, refresh])

  const getItemSet = useCallback(() => {
    return cart?.getItemSet()
  }, [ cart ])

  const getItemsBySlot = useCallback((slot: CartItemSlot) => {
    return cart.getItemsBySlot(slot)
  }, [ cart ])

  const updateItemSet = useCallback((itemSet: CartItemSet) => {
    cart?.selectSet(itemSet)
    cart?.loadDefaultItems()
    cart?.save()
    refresh()
  }, [cart, refresh])

  const updateShipping = useCallback(() => {
    cart?.updateShipping()
    cart?.save()
    refresh()
  }, [cart, refresh])

  const clear = useCallback(() => {
    cart?.clear()
    cart?.save()
    refresh()
  }, [cart, refresh])

  const subtotal = cart.getSubTotal()

  return (
    <CartContext.Provider
      value={{
        addItem,
        addCartItem,
        clear,
        items,
        msrp,
        refresh,
        removeItem,
        savingsPercent,
        subtotal,
        total,
        getItemSet,
        getItemsBySlot,
        updateItemSet,
        updateShipping,
        upgrades,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}
